import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

import Swiper from 'swiper/bundle'; // import Swiper JS ALL
import List from 'list.js';

/*
 * Common
*/

document.addEventListener('DOMContentLoaded', function () {
  const homePage = document.getElementById('home');
  if (homePage) {

    // Hero
    const swiperWrapper = document.querySelector('.hero-swiper');
    const slides = swiperWrapper.querySelectorAll('.hero-swiper-slide');
    const slideCount = slides.length;

    const heroSwiper = new Swiper('.hero-swiper', {
      loop: true,
      effect: 'fade',
      autoHeight: true,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      /*
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      */
      autoplay: slideCount > 1 ? {
        delay: 3500,
        disableOnInteraction: false
      } : false,
      speed: 1000,
    });


    /* ABOUT */
    const aboutSection = document.getElementById("about");
    const moreBtn = aboutSection.querySelector(".more-btn a");
    const moreElements = aboutSection.querySelectorAll(".more");

    moreBtn.addEventListener("click", function() {
      moreElements.forEach(function(element) {
        if (element.style.display === "none" || element.style.display === "") {
          element.style.display = "block";
        } else {
          element.style.display = "none";
        }
      });

      if (moreBtn.textContent === "MORE") {
        moreBtn.textContent = "CLOSE";
      } else {
        moreBtn.textContent = "MORE";
      }
    });

  }
});



/* WORK LIST: import List from 'list.js' */
var currentPage = window.location.pathname;

var options = {
    valueNames: [],
    listClass: 'work-list',
    // page: 24 // デフォルトで24件表示
};

var userList = new List('list-container', options);


// 「Show More」ボタンの表示・非表示制御
var showMoreButton = document.getElementById('show-more');
function toggleShowMoreButton(filterValue) {
  if (userList.matchingItems.length > 24 && filterValue === 'all') {
    showMoreButton.style.display = 'block';
  } else {
    showMoreButton.style.display = 'none';
  }
}


// ページ別の初期設定
if (currentPage === '/') {
    // トップページの設定：デフォルトで24件表示
    userList.show(1, 24);
} else if (currentPage === '/work') {
    // 一覧ページの設定：全件表示
    userList.show(1, userList.matchingItems.length);
}

// フィルターラジオボタンの変更イベント
document.querySelectorAll('input[name="filter"]').forEach(function(radio) {
  radio.addEventListener('change', function() {
    var filterValue = this.value;
    if (filterValue === 'all') {
      if (currentPage === '/') {
        // トップページでは24件表示
        userList.filter();
        userList.show(1, 24);
      } else if (currentPage === '/work') {
        // 一覧ページでは全件表示
        userList.filter();
        userList.show(1, userList.matchingItems.length);
      }
    } else {
      // フィルタリング時は全件表示
      userList.filter(function(item) {
          return item.elm.getAttribute('data-tag') === filterValue;
      });
      userList.show(1, userList.matchingItems.length);
    }

    if (currentPage === '/') {
      // ボタンの表示状態を更新
      toggleShowMoreButton(filterValue);
    }
  });
});

// フィルターselectボックスの変更イベント
document.getElementById('filter-select').addEventListener('change', function() {
  var filterValue = this.value;
  if (filterValue === 'all') {
    if (currentPage === '/') {
      // トップページでは24件表示
      userList.filter();
      userList.show(1, 24);
    } else if (currentPage === '/work') {
      // 一覧ページでは全件表示
      userList.filter();
      userList.show(1, userList.matchingItems.length);
    }
  } else {
    // フィルタリング時は全件表示
    userList.filter(function(item) {
        return item.elm.getAttribute('data-tag') === filterValue;
    });
    userList.show(1, userList.matchingItems.length);
  }

  if (currentPage === '/') {
    // ボタンの表示状態を更新
    toggleShowMoreButton(filterValue);
  }
});


/* WORK LIST: PhotoSwipe */
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

// Icon
// const leftArrowSVGString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 100 125" width="100" height="125"><path d="M5,50L50,5l3,3L11,50l42,42l-3,3L5,50z M92,95l3-3L53,50L95,8l-3-3L47,50L92,95z"/></svg>';
const leftArrowSVGString = '';
const closeSVGString = '';

// Padding
var padding = 60;

var windowSize = window.innerWidth;
if (windowSize < 768) {
  padding = 20;
} else {
  padding = 60;
}

// Options
/*
const PsOptions = {
};
*/

// Photoswipeを起動する関数
function openPhotoSwipe(galleryItems) {
    const lightbox = new PhotoSwipeLightbox({
      // to apply styles just to this instance of PhotoSwipe
      mainClass: 'pswp--custom',

      // gallery: '#gallery-photoswipe',
      // gallery: '.work-list',
      // children: '.post',
      gallery: false, // デフォルトのギャラリー要素を無効化
      children: false, // デフォルトの子要素を無効化

      // pswpModule: PhotoSwipe,
      pswpModule: () => import('photoswipe'),

      // キャプションを表示する設定を追加
      dataSource: galleryItems,
      /*
      captionContent: function (slide) {
          const item = galleryItems[slide.index];
          return item.title ? `<div class="pswp-caption-content">${item.title}</div>` : '';
      },
      captionContent: function (slide) {
          const item = galleryItems[slide.index];
          return item.title ? `<div class="pswp-caption-content">${item.title}</div>` : '';
      },

      slideContent: (slide) => {
          const item = galleryItems[slide.index];
          const captionElement = document.createElement('div');
          captionElement.className = 'pswp__caption__center';

          if (item.title) {
              captionElement.innerHTML = item.title;
          } else {
              captionElement.innerHTML = '';
          }

          slide.container.appendChild(captionElement);
      },
      */

      // Styling
      // arrowPrev: false,
      // arrowNext: false,
      zoom: false,
      // close: false,
      // counter: false

      bgOpacity: 1,
      padding: { top: padding, bottom: padding, left: padding, right: padding },

      // Icon: arrowPrevSVG, arrowNextSVG, closeSVG, zoomSVG
      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: leftArrowSVGString,
      closeSVG: closeSVGString,

      // Transition
      showHideAnimationType: 'fade', // fade, zoom, none

      // Click actions
      imageClickAction: 'next',
      tapAction: 'next',

    });

    lightbox.on('uiRegister', () => {
        lightbox.pswp.ui.registerElement({
            name: 'caption',
            order: 9,
            isButton: false,
            appendTo: 'wrapper',
            onInit: (el, pswp) => {
                lightbox.pswp.on('change', () => {
                    const currSlideElement = lightbox.pswp.currSlide.data.element;
                    const currItem = galleryItems[lightbox.pswp.currIndex];
                    el.innerHTML = currItem.title || '';
                });
            }
        });
    });

    lightbox.init();
    // lightbox.loadAndOpen(0);
    lightbox.loadAndOpen(0, galleryItems);
}

// 親要素（ここでは "body"）にイベントリスナーを委譲
document.body.addEventListener('click', (event) => {
    // クリックされた要素の祖先に "post" クラスを持つ要素があるかを探す
    const postElement = event.target.closest('.post');

    if (postElement && postElement.id && postElement.id.startsWith('open-')) {
        const postId = postElement.id.split('-')[1];  // "open-"を取り除いたID部分を取得
        const galleryItems = galleries[postId];        // 該当するギャラリーを取得

        if (galleryItems) {
            openPhotoSwipe(galleryItems);
        }
    }
});

/* Old
// ページの読み込み後にクリックイベントを追加
document.addEventListener('DOMContentLoaded', () => {
    Object.keys(galleries).forEach(postId => {
        const buttonId = `open-${postId}`;
        const galleryItems = galleries[postId];

        const button = document.getElementById(buttonId);
        if (button) {
            button.onclick = () => {
              console.log(button);
                openPhotoSwipe(galleryItems);
            };
        }
    });
});
*/

/*
// Old - HTMLにギャラリーを追加
const galleryElement = document.createElement('div');
galleryElement.id = 'gallery';
document.body.appendChild(galleryElement);

// 初期状態ではギャラリーリンクを作成しないが、必要に応じて以下のようにリンクを作成できる
function createGalleryLinks(galleryItems) {
    galleryElement.innerHTML = '';  // 既存のリンクをクリア
    galleryItems.forEach((item, index) => {
        const link = document.createElement('a');
        link.href = item.src;
        link.dataset.pswpWidth = item.w;
        link.dataset.pswpHeight = item.h;
        link.dataset.pswpIndex = index;
        link.textContent = item.title;
        galleryElement.appendChild(link);
    });
}
*/
